<button class="text-gray-900 p-3 rounded-lg text-sm font-medium" 
    [ngStyle]="{ 'bg-gray-900' : disabled == 'true' }" 
    [ngClass]="styles">
    {{ name | translate}}
</button>